enum InvoiceMode {
  Standard = 0,
  Internal = 1
}

export default InvoiceMode;
